import { useMemo } from 'react';
import { useTranslation } from 'next-i18next';
import { Radio, Select, SelectItemType } from '@zep/ui';
import S from './SelectConcurrencyUsers.module.scss';
const TransValue = ({
  value
}: {
  value: string;
}) => {
  const {
    t
  } = useTranslation(['subscription']);
  return <>
      {value === 'subscription:pricing.plansEnterprise.peopleUnlimited' ? t('subscription:pricing.plansEnterprise.peopleUnlimited') : t('subscription:pricing.plansCommon.peopleNumber', {
      ccu: value
    })}
    </>;
};
export const SelectConcurrencyUsers = (props: SelectConcurrencyUsersProps) => {
  const {
    availableCounts,
    onChangeMaxCcu,
    selectedMaxCcu,
    onChangePeriod,
    selectedPeriod,
    discountRate
  } = props;
  const {
    t
  } = useTranslation(['subscription'], {
    useSuspense: true
  });
  const options = useMemo(() => availableCounts.map(value => ({
    value: String(value),
    name: <TransValue value={value.toString()} /> as unknown as string
  })), [availableCounts]);
  const selectedValue = useMemo(() => options.find(option => {
    const convertedMaxCcu = selectedMaxCcu === Infinity ? 'subscription:pricing.plansEnterprise.peopleUnlimited' : selectedMaxCcu.toString();
    return option.value === convertedMaxCcu;
  }), [options, selectedMaxCcu]);
  const handleRadioChange = (value: number) => {
    onChangePeriod(value);
  };
  const handleSelectChange = ({
    value
  }: SelectItemType) => {
    const maxCcu = Number(value);
    onChangeMaxCcu(isNaN(maxCcu) ? Infinity : maxCcu);
  };
  return <div className={S.wrapper} data-sentry-component="SelectConcurrencyUsers" data-sentry-source-file="SelectConcurrencyUsers.tsx">
      <div className={S.left}>
        <span className={S.title}>
          {t('subscription:pricing.selectPlan.maxCcu')}
        </span>
        <Select size="md" width={'230px'} optionsHeight={'max-content'} options={options} value={selectedValue} onChange={handleSelectChange} data-sentry-element="Select" data-sentry-source-file="SelectConcurrencyUsers.tsx" />
      </div>
      <div className={S.right}>
        <Radio label={<span>{t('subscription:pricing.selectPlan.monthlyPayment')}</span>} labelPlacement={'left'} onChange={() => handleRadioChange(30)} checked={selectedPeriod === 30} data-sentry-element="Radio" data-sentry-source-file="SelectConcurrencyUsers.tsx" />
        <Radio label={<span>
              {t('subscription:pricing.selectPlan.annuallyPayment')}
              {discountRate > 0 && <span className={S.discount_chip}>
                  {t('subscription:pricing.selectPlan.discount', {
            amount: `${discountRate}%`
          })}
                </span>}
            </span>} labelPlacement={'left'} onChange={() => handleRadioChange(365)} checked={selectedPeriod === 365} data-sentry-element="Radio" data-sentry-source-file="SelectConcurrencyUsers.tsx" />
      </div>
    </div>;
};
type SelectConcurrencyUsersProps = {
  defaultValue: number;
  availableCounts: string[];
  onChangeMaxCcu: (value: number) => void;
  selectedMaxCcu: number;
  onChangePeriod: (value: number) => void;
  selectedPeriod: number;
  discountRate: number;
};